const formatPrice = (price) => {
  const priceString = price.toString();
  return `${priceString.substr(0, priceString.length - 3)} ${priceString.substr(price.toString().length - 3)}`;
};

export default formatPrice;



// WEBPACK FOOTER //
// ./src/utils/formatPrice.js